<template>
  <Page>
    <SidePageColumn side="left">
      <div class="pl-5 r-5">
        <div class="h2 grey--text mt-2 mb-0">Directory Alphabets</div>
        <v-btn
          small
          width="100"
          tile
          color="primary"
          :disabled="is_loading"
          v-for="(alpha, index) in alphabets"
          :key="index"
          :outlined="alpha != selected_alpha"
          @click="go_to_section(alpha)"
        >
          <v-icon left>mdi-eye</v-icon>
          {{ alpha }}
        </v-btn>
      </div>
      <FeaturedSidePromotions
        :page="page"
        section="left"
      ></FeaturedSidePromotions>
    </SidePageColumn>

    <CenterPageColumn :has_nav_bar="true">
      <CenterNavbar
        :crumps="[]"
        title="Business Directory"
        :width_class="page_info.center_width_class"
      ></CenterNavbar>

      <div class="componet-has-nav-bar white pt-5" style="min-height: 700px">
        <v-row
          no-gutters
          v-for="(group, index) in business_groups"
          :key="index"
        >
          <v-col cols="12">
            <div style="width: 250px">
              <CardedSectionHeader
                icon="mdi-group"
                :label="index.toUpperCase()"
                :id="'directory_alpha_section_' + index"
              ></CardedSectionHeader>
            </div>
          </v-col>
          <v-col cols="12">
            <v-row v-if="group.businesses.length > 0">
              <v-col
                no-gutters
                cols="6"
                v-for="(business, index) in group.businesses"
                :key="index"
                class="pl-8 pr-8"
              >
                <div
                  class="d-flex justify-space-between pa-2 pointer elevation-5"
                  :id="'directory_bsns_id_' + business.id"
                  @click="on_click_business_in_directory(business)"
                >
                  <div class="grey lighten-5 pa-1 round-4 elevation-2">
                    <v-img
                      :src="business.logo"
                      :width="logo_width"
                      :height="logo_width"
                      :max-width="logo_width"
                      :min-height="logo_width"
                      grey
                    >
                    </v-img>
                  </div>
                  <div
                    class="flex-grow-1 pa-2 pb-0 d-flex flex-column justify-space-between"
                    :style="'min-height:' + (logo_width + 10) + 'px'"
                  >
                    <div>
                      <div class="d-flex justify-space-between">
                        <div class="text-left">
                          <v-rating
                            background-color="warning lighten-1"
                            color="warning"
                            empty-icon="mdi-star-outline"
                            full-icon="mdi-star"
                            half-icon="mdi-star-half-full"
                            hover
                            length="5"
                            size="15"
                            :value="parseFloat(business.rating)"
                            :readonly="true"
                          ></v-rating>
                        </div>
                        <div class="text-right">
                          <span class="success--text local-badge"
                            ><small>
                              {{
                                parseInt(business.is_local_company) == 1
                                  ? "LOCAL COMPANY"
                                  : "NOT LOCAL"
                              }}
                            </small></span
                          >
                        </div>
                      </div>
                      <div class="text-left directory-business-name">
                        <span class="success--text mr-1"
                          ><b>#{{ business.id }}</b></span
                        >
                        {{ business.name }}
                      </div>
                      <div class="text-left directory-business-tagline">
                        {{ business.tag_line }}
                      </div>
                    </div>
                    <div
                      class="grey lighten-4 d-flex justify-space-between pa-1"
                    >
                      <v-chip
                        x-small
                        label
                        class="white--text ml-2"
                        :color="business.open_btn.color"
                        ><b class="">
                          {{ business.open_btn.open_status }}</b
                        ></v-chip
                      >
                      <v-btn
                        x-small
                        width="100"
                        outlined
                        color="success"
                        :disabled="is_loading"
                      >
                        <v-icon left>mdi-eye</v-icon>
                        view
                      </v-btn>
                    </div>
                  </div>
                </div>
                <v-divider></v-divider>
              </v-col>
            </v-row>
            <v-row
              v-if="group.businesses.length == 0 && parseInt(group.page) > 0"
            >
              <v-col no-gutters cols="12">
                //nyd <br />
                //Big Sad emogi no businesses here
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="text-center">
            <v-btn
              rounded
              filled
              color="success"
              :disabled="is_loading"
              class="mt-5 mb-5"
              @click="on_click_load_group(index)"
              v-if="parseInt(group.page) == 0"
            >
              Load Businesses Of Group {{ index }}
            </v-btn>
            <v-btn
              rounded
              filled
              color="success"
              :disabled="is_loading"
              class="mt-5 mb-5"
              @click="on_click_load_group(index)"
              v-if="
                parseInt(group.page) > 0 &&
                parseInt(group.number_loaded) < parseInt(group.num_available)
              "
            >
              Load Next
              {{
                comma(
                  load_next_num(
                    page_size,
                    group.number_loaded,
                    group.num_available
                  )
                )
              }}
              Businesses Of Group {{ index }}
            </v-btn>
          </v-col>
        </v-row>
      </div>

      <Footer
        :is_loading="is_loading"
        @on-hide-loader="$emit('on-hide-loader')"
        @on-show-loader="$emit('on-show-loader')"
      ></Footer>
    </CenterPageColumn>

    <SidePageColumn side="right">
      <SelfPromoAdd :page="page" section="right"></SelfPromoAdd>
      <HomeSideAdsContainer
        :page="page"
        side="right"
        :number_of_ads="3"
      ></HomeSideAdsContainer>
    </SidePageColumn>
  </Page>
</template>

<script>
import Page from "./../../components/Page";
import SidePageColumn from "./../../components/SidePageColumn";
import FeaturedSidePromotions from "./../../components/FeaturedSidePromotions";
import SelfPromoAdd from "./../../components/SelfPromoAdd";
import HomeSideAdsContainer from "./../../components/HomeSideAdsContainer";
import CenterPageColumn from "./../../components/CenterPageColumn";
import CardedSectionHeader from "./../../components/CardedSectionHeader";
import CenterNavbar from "./../../components/CenterNavbar";
import Footer from "./../../components/CenterFooter";

import page_info from "./../../lib/page_info";
import Utils from "./../../lib/Utils";
import ServerClient from "./../../lib/ServerClient";
export default {
  name: "Directory",
  components: {
    Page,
    SidePageColumn,
    FeaturedSidePromotions,
    SelfPromoAdd,
    HomeSideAdsContainer,
    CenterPageColumn,
    CenterNavbar,
    Footer,
    CardedSectionHeader,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    page: "directory",
    page_info: page_info,
    business_groups: {},
    alphabets: [
      "a",
      "b",
      "c",
      "d",
      "e",
      "f",
      "g",
      "h",
      "i",
      "j",
      "k",
      "l",
      "m",
      "n",
      "o",
      "p",
      "q",
      "r",
      "s",
      "t",
      "u",
      "v",
      "w",
      "x",
      "y",
      "z",
    ],
    page_size: 3,
    selected_alpha: "a",
    logo_width: 100,
    holidays: [],
    // image_link: require("../../assets/logo_vue.png"),
    is_business_open: {
      msg: "... Verifying Status, please wait",
      color: "default",
      is_open: -1,
      open_status: "Open or Closed",
    },
  }),
  methods: {
    get_open_status(business) {
      var is_open = false;
      var days = [
        "sunday",
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
      ];
      var this_device_day = new Date().getDay();
      var device_day = days[this_device_day];

      var op_value = business[device_day + "_openning_time_display"];
      var cl_value = business[device_day + "_closing_time_display"];

      if (op_value.length == 0) {
        op_value = "not set";
      }
      if (cl_value.length == 0) {
        cl_value = "not set";
      }

      if (
        op_value != "closed" &&
        cl_value != "closed" &&
        op_value != "not set" &&
        cl_value != "not set"
      ) {
        //then lets get the times schedule times
        var start_x = parseFloat(business[device_day + "_openning_time_value"]); //13:26 --> 13.26 (13.26 is how we saved the time in the db)
        var closes_x = parseFloat(business[device_day + "_closing_time_value"]); //08:00 --> 8.00  (8.26 is how we saved the time in the db)
        var device_date_x = new Date();
        var now_device_hours = device_date_x.getHours();
        var now_device_mins = device_date_x.getMinutes();
        var now_device_time = parseFloat(
          now_device_hours + "." + now_device_mins
        );
        if (now_device_time >= start_x && now_device_time <= closes_x) {
          is_open = true;
        }
      } else if (op_value == "not set" || cl_value != "not set") {
        is_open = -1;
      }

      return is_open;
    },
    get_holiday_open_status(business) {
      var DateTodayDevice = new Date();
      var TodayDeviceDate = DateTodayDevice.getDate();
      var TodayDeviceMonth = DateTodayDevice.getMonth();

      var is_open = false;
      var is_a_holiday_today = false;
      if (business && this.holidays && business.business_holliday_schedules) {
        //index the business holiday entries
        var indexed_business_holidays = {};
        for (
          var index = 0;
          index < business.business_holliday_schedules.length;
          index++
        ) {
          var schedule = business.business_holliday_schedules[index];
          indexed_business_holidays[parseInt(schedule.holliday_id)] = schedule;
        }

        //go through the application holidays config
        for (var index = 0; index < this.holidays.length; index++) {
          var holiday = this.holidays[index];

          //used to detect for today
          var DateForHoliday = new Date(holiday.starts_on);
          var DateForHolidayDate = DateForHoliday.getDate();
          var DateForHolidayMonth = DateForHoliday.getMonth();

          if (
            TodayDeviceDate != DateForHolidayDate ||
            TodayDeviceMonth != DateForHolidayMonth
          ) {
            //continue its not a holiday today so no need to check further
            continue;
          }

          is_a_holiday_today = true;

          //look for this holiday from the business object
          if (indexed_business_holidays[parseInt(holiday.id)]) {
            var schedule = indexed_business_holidays[parseInt(holiday.id)];
            var op_value = schedule.opens;
            var cl_value = schedule.closes;
            if (op_value.length == 0) {
              op_value = "not set";
            }
            if (cl_value.length == 0) {
              cl_value = "not set";
            }
            //for the business to be oppened on this holiday it must be today
            //and having a schedule setup, thats why this logic is written here
            if (schedule.opens_time != "closed") {
              //then lets get the times schedule times
              var start_x = parseFloat(schedule.opens_time); //13:26 --> 13.26 (13.26 is how we saved the time in the db)
              var closes_x = parseFloat(schedule.ends_time); //08:00 --> 8.00  (8.26 is how we saved the time in the db)
              var device_date_x = new Date();
              var now_device_hours = device_date_x.getHours();
              var now_device_mins = device_date_x.getMinutes();
              var now_device_time = parseFloat(
                now_device_hours + "." + now_device_mins
              );
              if (now_device_time >= start_x && now_device_time <= closes_x) {
                is_open = true;
              }
            } else {
              is_open = false;
            }
            break;
          } else {
            //because the business is missing a holiiday entry
            is_open = -1;
          }
        }
      } else {
        is_open = -1; //not set
      }

      return {
        is_open: is_open,
        is_a_holiday_today: is_a_holiday_today,
      };
    },
    set_is_business_open(business) {
      var holiday_schedules = this.get_holiday_open_status(business);
      var normal_schedule_open = this.get_open_status(business);
      var msg = "";
      var color = "";
      var is_open = false;
      var open_status = "";
      var is_holiday_open = holiday_schedules.is_open;
      var is_a_holiday_today = holiday_schedules.is_a_holiday_today;
      var is_week_open = normal_schedule_open;

      if (is_a_holiday_today && is_holiday_open === -1) {
        //note the === strict comparison used here
        msg =
          "This business may be open or close, because there is no schedule setup for this holiday";
        color = "orange";
        is_open = -1;
        open_status = "Open or Closed";
      } else if (is_a_holiday_today && is_holiday_open === false) {
        //note the === strict comparison used here
        msg = "This business is CLOSED, by this time on this holiday";
        color = "red";
        is_open = false;
        open_status = "Closed";
      } else if (is_a_holiday_today && is_holiday_open === true) {
        //note the === strict comparison used here
        msg = "This business is OPEN, by this time on this holiday";
        color = "green";
        is_open = true;
        open_status = "Open";
      } else if (is_week_open === true) {
        //note the === strict comparison used here
        msg = "This business is OPEN";
        color = "green";
        is_open = true;
        open_status = "Open";
      } else if (is_week_open === false) {
        //note the === strict comparison used here
        msg = "This business is CLOSED";
        color = "red";
        is_open = false;
        open_status = "Closed";
      } else if (is_week_open === -1) {
        msg =
          "This business may be open or close, because there is no schedule setup for today";
        color = "orange";
        is_open = -1;
        open_status = "Open or Closed";
      }
      return {
        msg: msg,
        color: color,
        is_open: is_open,
        open_status: open_status,
      };
    },
    load_next_num(page_size, number_loaded, num_available) {
      var num = 0;
      page_size = parseInt(page_size);
      number_loaded = parseInt(number_loaded);
      num_available = parseInt(num_available);
      if (number_loaded >= num_available) {
        num = 0;
      } else {
        num = num_available - number_loaded;
      }
      if (num > page_size) {
        num = page_size;
      }
      return num;
    },
    on_click_load_group(alpha) {
      this.selected_alpha = alpha;
      this.load_businesses_of_alpha(this.selected_alpha);
    },
    go_to_section(alpha) {
      this.selected_alpha = alpha;
      var config = this.business_groups[alpha];
      if (parseInt(config.page) <= 0) {
        this.scroll_to_secton("directory_alpha_section_" + alpha);
        this.load_businesses_of_alpha(this.selected_alpha);
      } else {
        this.scroll_to_secton("directory_alpha_section_" + alpha);
      }
    },
    comma(v) {
      if (v < 10) {
        v = "0" + v.toString();
      }
      return Utils.add_commas(v);
    },
    scroll_to_secton(lmnt_id) {
      try {
        var options = {
          offset: 50,
          duration: 1000,
          easing: "easeInOutCubic",
        };
        this.$vuetify.goTo("#" + lmnt_id, options);
      } catch (error) {
        console.log(
          "Error scrolling to section on directory page ",
          error,
          lmnt_id
        );
      }
    },
    load_directory_page_dependencies() {
      this.$emit("on-show-loader");
      ServerClient.Holidays.get_holidays(
        {},
        (res) => {
          this.$emit("on-hide-loader");
          this.holidays = res;
          this.load_businesses_of_alpha(this.selected_alpha);
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors loading holidays on the directories page ",
            errors
          );
        }
      );
    },
    load_businesses_of_alpha(alpha) {
      var config = this.business_groups[alpha];
      if (parseInt(config.page) <= 0) {
        //this is going to be the first time
        //so we inquire for statistics
        this.fetch_statistics_first(alpha);
      } else {
        //check if we have more data to fetch
        if (parseInt(config.number_loaded) < parseInt(config.num_available)) {
          this.fetch_data(alpha);
        } else {
          //do nothing, no more data to fetch
        }
      }
    },
    fetch_data(alpha) {
      var vm = this;
      vm.$emit("on-show-loader");
      ServerClient.Directory.get_businesses_starting_wih_alpha(
        {
          num_available: this.business_groups[alpha].num_available,
          number_loaded: this.business_groups[alpha].number_loaded,
          page: this.business_groups[alpha].page + 1,
          page_size: this.page_size,
          alpha: alpha,
        },
        (res) => {
          //console.log("Directory results ", res);
          var sent_query = res._box;

          var b_list = [];
          for (var index = 0; index < res.businesses.length; index++) {
            var business = res.businesses[index];
            //get open status
            business.open_btn = vm.set_is_business_open(business);
            b_list.push(business);
          }
          b_list = vm.business_groups[sent_query.alpha].businesses.concat(
            b_list
          );

          vm.business_groups[sent_query.alpha].number_loaded = b_list.length;
          vm.business_groups[sent_query.alpha].businesses = b_list;
          vm.business_groups[sent_query.alpha].page = parseInt(sent_query.page);
          //console.log("Alpha group ", vm.business_groups[sent_query.alpha]);
          vm.$emit("on-hide-loader");

          var first_fetched_id =
            res.businesses.length > 0 ? parseInt(res.businesses[0].id) : 0;
          //scroll to the first added business
          if (first_fetched_id > 0) {
            setTimeout(() => {
              vm.scroll_to_secton("directory_bsns_id_" + first_fetched_id);
            }, 1000);
          } else {
            setTimeout(() => {
              vm.scroll_to_secton("directory_alpha_section_" + alpha);
            }, 1000);
          }
        },
        (errors) => {
          vm.$emit("on-hide-loader");
          console.log(
            "Errors while loading businesses starting with alpha " + alpha,
            errors
          );
        }
      );
    },
    fetch_statistics_first(alpha) {
      var vm = this;
      vm.$emit("on-show-loader");
      ServerClient.Directory.get_pagination_stats_of_alpha(
        {
          alpha: alpha,
        },
        (res) => {
          vm.$emit("on-hide-loader");
          //update stats
          vm.business_groups[alpha].num_available = parseInt(res);
          vm.fetch_data(alpha);
        },
        (errors) => {
          vm.$emit("on-hide-loader");
          console.log(
            "Errors while loading statistics of alpha " + alpha,
            errors
          );
        }
      );
    },
    on_click_business_in_directory(business){
        this.$router.push("/businesses/" + business.id);
    }
  },
  mounted() {
    var grouping = {};
    for (var index = 0; index < this.alphabets.length; index++) {
      var ch = this.alphabets[index];
      grouping[ch] = {
        businesses: [],
        num_available: 0,
        number_loaded: 0,
        page: 0,
      };
    }
    this.business_groups = grouping;
    this.selected_alpha = "a";
    this.load_directory_page_dependencies();
  },
};
</script>